// src/pages/Login.js — Admin portal restricted to owner/team_leader roles
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { post } from '../utils/api';

const ALLOWED_ROLES = ['owner', 'team_leader'];

function normalizePhone(raw) {
  let p = raw.trim().replace(/\s+/g, '');
  if (p.startsWith('+91')) p = p.slice(3);
  else if (p.startsWith('0091')) p = p.slice(4);
  else if (p.startsWith('91') && p.length === 12) p = p.slice(2);
  return p;
}

export default function Login() {
  const [phone, setPhone]     = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await post('/api/auth/login', { phone, password });

      if (!ALLOWED_ROLES.includes(data.user?.role)) {
        setError('Access denied — the admin portal is for owners and team leaders only.');
        return;
      }

      localStorage.setItem('dms_token', data.accessToken);
      localStorage.setItem('dms_user', JSON.stringify(data.user));
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Invalid phone or password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-blue-900 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🚚</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-800">DMS Admin Portal</h1>
          <p className="text-sm text-gray-500 mt-1">Delivery Management System</p>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
            <input
              type="text"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="Enter login mobile number"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {error && (
            <div className="mb-4 px-4 py-3 bg-red-50 border border-red-300 rounded-xl text-sm text-red-700">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-blue-900 text-white rounded-xl font-semibold text-sm hover:bg-blue-800 transition-colors disabled:opacity-60"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-xs text-gray-400 mt-6">
          Delivery Management System v1.0
        </p>
      </div>
    </div>
  );
}
